var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "modifications", title: "Modifications to the Service" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Font Awesome reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, the Service (or any part\n        thereof) with or without notice.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Font Awesome shall not be liable to you or to any third-party for any modification, suspension or discontinuance of the Service.\n      "
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }